import styled from 'styled-components';

const Styled = styled.div`
    .description {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
export default Styled;
